export const isAbilityScoreShown = (value: string | null | undefined) => value !== "zcela bez možnosti sebehodnocení";
